import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-withdraw',
    templateUrl: './confirm-withdraw.component.html',
    styleUrls: ['./confirm-withdraw.component.scss'],
    standalone: false
})
export class ConfirmWithdrawComponent {
  amount: number;
  balance: number;
  // FRC-858: current hold, so the remaining balance can explain itself.
  pendingAmount: number = 0;

  constructor(public activeModal: NgbActiveModal) {}

  /** FRC-858: account balance left after this request. */
  get newBalance(): number {
    return Math.max(0, +((this.balance ?? 0) - (this.amount ?? 0)).toFixed(2));
  }

  /**
   * FRC-858: how much of the remaining balance is still held after this request.
   * Existing holds don't move, so this is simply the current hold — capped at the
   * remaining balance so the sub-line can never claim more than the row above it.
   */
  get onHoldAfter(): number {
    return Math.max(0, Math.min(this.pendingAmount ?? 0, this.newBalance));
  }

  confirm() {
    this.activeModal.close();
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
